import React from 'react';
import PropTypes from 'prop-types';
import {Text} from "./Text";
import {RichContent} from "./RichContent";
import { Heading } from "./Heading";

export const ServicesDescriptionElement = (props) => {

	const style = {
		color: `${ props.linkColor}`
	}

	return(
		<li className="services--description-list-item description">
			<Heading content={props.title.titleText} link={props.title.url} style={style} size="h2"/>
			<hr/>
			<ul className="description__list--inner">
				{ props.details.map((detail, i) => {
					return(
						<li className="description__list--inner-item" key={i}>
							<span className="item-label">
								<Text content={detail.detailLabel}/>
							</span>
							<span className="item-name">
								<Text content={detail.detail}/>
							</span>
						</li>
					)})
				}
				
			</ul>
			<RichContent dangerous={props.description}/>
		</li>

	);
};

ServicesDescriptionElement.propTypes = {
	description: PropTypes.string,
	title: PropTypes.object,
	details: PropTypes.array,
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/ServicesDescriptionElement.js